import $ from 'jquery';
import Rails from '@rails/ujs';
import BootstrapModal from 'bootstrap/js/dist/modal';

$(() => {
  onceEventListeners();
});

const onceEventListeners = () => {
  $('#update-confirmation-button').on('click', updateWithConfirmationAndSubmit);
};

const showUpdateConfirmationModal = () => {
  hideShowBookingModal();
  const $updateConfirmationModal = $('#update-confirmation-modal');
  $updateConfirmationModal.modal('show');
};

window.showUpdateConfirmationModal = showUpdateConfirmationModal;

const hideUpdateConfirmationModal = () => {
  const $updateConfirmationModal = $('#update-confirmation-modal');
  $updateConfirmationModal.modal('hide');
};

const updateWithConfirmationAndSubmit = () => {
  const action = $('input[name=update-type]:checked').val();
  const $updateBookingForm = $('#update-booking-form');
  const $updateConfirmation = $updateBookingForm.find('#update-confirmation');
  $updateConfirmation.val(action);
  Rails.fire($updateBookingForm.get(0), 'submit');
  hideUpdateConfirmationModal();
};

const displayShowBookingModal = () => {
  const $bookingShowModal = $('#booking-show-modal');
  $bookingShowModal.modal('show');

  if (typeof window.latestConfig !== 'undefined') {
    window.latestConfig.startDate = $bookingShowModal
      .find('input[name="start_date"]')
      .val();
  }
};

window.displayShowBookingModal = displayShowBookingModal;

const displayShowBookingModalNoReset = () => {
  const $bookingShowModal = $('#booking-show-modal');
  $bookingShowModal.modal('show');
};

window.displayShowBookingModalNoReset = displayShowBookingModalNoReset;

const showDestroyConfirmationModal = () => {
  hideShowBookingModal();
  const $destroyConfirmationModal = $('#destroy-confirmation-modal');
  $destroyConfirmationModal.modal('show');
};

window.showDestroyConfirmationModal = showDestroyConfirmationModal;

const hideDestroyConfirmationModal = () => {
  const $destroyConfirmationModal = $('#destroy-confirmation-modal');
  $destroyConfirmationModal.modal('hide');
};

window.hideDestroyConfirmationModal = hideDestroyConfirmationModal;

const hideShowBookingModal = () => {
  const $bookingShowModal = $('#booking-show-modal');
  $bookingShowModal.modal('hide');
};

window.hideShowBookingModal = hideShowBookingModal;

const displayCreateBookingModal = (e) => {
  const $bookingRequestModal = $('#booking-request-modal');
  $bookingRequestModal.find('.alert').addClass('d-none');
  $bookingRequestModal.modal('show');
  $bookingRequestModal.on('hidden.bs.modal', function () {
    if (e) e.guide.clearGuideElement();
  });
};

window.displayCreateBookingModal = displayCreateBookingModal;

const hideCreateBookingModal = () => {
  const $bookingRequestModal = $('#booking-request-modal');
  if (BootstrapModal.getInstance($bookingRequestModal)) {
    BootstrapModal.getInstance($bookingRequestModal).hide();
  } else {
    $bookingRequestModal.find('.btn-close').click();
  }
};

window.hideCreateBookingModal = hideCreateBookingModal;
